
import { IContentCreator } from "../interfaces/IContentCreator";
import { Environment } from './Environment';
import { IMyContent } from '../interfaces/IMyContent';
import { IMessageFilter } from '../interfaces/IMessageFilter';
import { FilterService } from '../components/messages/Filter.service';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';

export default class ContentCreatorService {

  public static getMyContentInstances(environment: "Development" | "Test" | "Production", token: string, tenant: string): Promise<IMyContent> {
    return new Promise<IMyContent>((resolve: (result: IMyContent) => void, reject: (error: any) => void): void => {
      if (environment && tenant && token) {
        const apiUrl: string = `${Environment.getEnvironmentForContentCreatorAPI(environment)}/${tenant}/content/my/instances`;
        new FetchProxy(
          apiUrl, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            'AuthToken': token
          }
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json();
          }).then((result: IMyContent) => {
            resolve(result);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static getMyContent(environment: "Development" | "Test" | "Production", token: string, tenant: string, skip?: number, filter?: IMessageFilter): Promise<IMyContent> {
    return new Promise<IMyContent>((resolve: (result: IMyContent) => void, reject: (error: any) => void): void => {
      if (environment && tenant && token) {
        const filterQueryString: string = !filter && filter == null ? "" : FilterService.parseFilterDataToQueryString(filter);
        const apiUrl: string = `${Environment.getEnvironmentForContentCreatorAPI(environment)}/${tenant}/content/my?take=10&skip=${skip ? skip : 0}` + `${filterQueryString.length > 0 ? filterQueryString : ""}`;
        new FetchProxy(
          apiUrl, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            'AuthToken': token
          }
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json();
          }).then((result: IMyContent) => {
            resolve(result);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static getWaitingForApproval(environment: "Development" | "Test" | "Production", token: string, tenant: string, skip?: number): Promise<IMyContent> {
    return new Promise<IMyContent>((resolve: (result: IMyContent) => void, reject: (error: any) => void): void => {
      if (environment && tenant && token) {
        const apiUrl: string = `${Environment.getEnvironmentForContentCreatorAPI(environment)}/${tenant}/content/waitingforapproval?take=10&skip=${skip ? skip : 0}`;
        new FetchProxy(
          apiUrl, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            'AuthToken': token
          }
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json();
          }).then((result: IMyContent) => {
            resolve(result);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static getBotMessages(environment: "Development" | "Test" | "Production", token: string, tenant: string, skip?: number): Promise<IMyContent> {
    return new Promise<IMyContent>((resolve: (result: IMyContent) => void, reject: (error: any) => void): void => {
      if (environment && tenant && token) {
        const apiUrl: string = `${Environment.getEnvironmentForContentCreatorAPI(environment)}/${tenant}/content/bot?take=10&skip=${skip ? skip : 0}`;
        new FetchProxy(
          apiUrl, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            'AuthToken': token
          }
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json();
          }).then((result: IMyContent) => {
            resolve(result);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static get(environment: "Development" | "Test" | "Production", token: string, tenant: string, instanceName: string): Promise<IContentCreator> {
    return new Promise<IContentCreator>((resolve: (result: IContentCreator) => void, reject: (error: any) => void): void => {
      if (environment && tenant && instanceName && token) {
        const apiUrl: string = `${Environment.getEnvironmentForContentCreatorAPI(environment)}/${tenant}/config/${instanceName}`;
        new FetchProxy(apiUrl, { method: "GET", credentials: "same-origin", headers: { 'AuthToken': token } })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json();
          }).then((result: IContentCreator) => {
            resolve(result);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static update(environment: "Development" | "Test" | "Production", token: string, tenant: string, instanceName: string, contentCreator: IContentCreator): Promise<number> {
    return new Promise<number>((resolve: (id: number) => void, reject: (error: any) => void): void => {
      if (environment && tenant && instanceName && token && contentCreator) {
        if (environment && tenant && instanceName && token) {
          const apiUrl: string = `${Environment.getEnvironmentForContentCreatorAPI(environment)}/${tenant}/config/${instanceName}`;
          new FetchProxy(apiUrl, {
            method: "POST",
            credentials: "same-origin",
            headers: { 'AuthToken': token },
            body: JSON.stringify(contentCreator)
          }).withContainer(sdkContainerInstance)
            .fetch()
            .then((response) => {
              if (!response.ok) {
                reject(response);
                return;
              }
              return response.json();
            }).then((id) => {
              resolve(id);
            })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        } else {
          resolve(null);
        }
      }
    });
  }

}